import { sendHttpRequest } from "lib/fetcher";

export const getRecentAlertCameras = async (camNum, alertRangeMinutes) => {
  return sendHttpRequest({
    method: "get",
    url:
      "/camera/cameras/recent_alerted?camNum=" +
      camNum +
      "&alertRangeMinutes=" +
      alertRangeMinutes,
  });
};
export function getSpeakerBySiteId(siteId, orgId?: number) {
  return sendHttpRequest({
    method: "get",
    url: "/speaker/speakers/for_sites?withAudio=true&siteIds=" + siteId,
    headers: {
      "x-org-id": orgId,
    },
  });
}
